import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';

@Injectable({
  providedIn: 'root'
})
export class HighChartsSetupService {

  public setupHighchartLocalization(lang: string) {
    // uses default: de, es, it, tr
    let decimalPoint = ',';
    let thousandsSep = '.';
    switch (lang) {
      case 'en': 
      case 'zh_CN':
      case 'ko-KR':
        decimalPoint = '.';
        thousandsSep = ',';
        break;
      case 'fr':
        thousandsSep = '\u202f';
        break;
      case 'pl':
        thousandsSep = '\u00a0';
        break;
    }
    
    Highcharts.setOptions({
      lang: {
        decimalPoint,
        thousandsSep
      }
    });
  }
}
